import request from '../utils/request';

// 收益比率信息接口
export interface ProfitRateInfo {
  id: number;
  min_num: number;
  max_num: number;
  bilv: number;
  days: number;
}

// 获取列表参数接口
export interface ProfitRateListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
}

// 创建收益比率参数接口
export interface CreateProfitRateParams {
  min_num: number;
  max_num: number;
  bilv: number;
  days: number;
}

// 更新收益比率参数接口
export interface UpdateProfitRateParams extends CreateProfitRateParams {
  id: number;
}

// 获取收益比率列表
export const getProfitRateList = (params: ProfitRateListParams) => {
  return request.get('/profit/list', { params });
};

// 创建收益比率
export const createProfitRate = (data: CreateProfitRateParams) => {
  return request.post('/profit/create', data);
};

// 更新收益比率
export const updateProfitRate = (data: UpdateProfitRateParams) => {
  return request.put('/profit/update', data);
};

// 删除收益比率
export const deleteProfitRate = (id: number) => {
  return request.delete(`/profit/delete/${id}`);
}; 